<template><svg id="artwork" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 80">
  <g>
    <polygon class="notificationCenter"
             points="25.58 75.5 5.72 41.1 26.87 4.5 69.15 4.5 90.28 41.1 70.43 75.5 25.58 75.5"/>
    <path fill="#fff" d="M66.55,9,85.08,41.1,67.83,71H28.18L10.92,41.1,29.47,9H66.55m5.2-9H24.27L.53,41.1,23,80H73L95.47,41.1,71.75,0Z"/>
  </g>
</svg>
</template>